/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateTriggerInstanceForm,
  CreateTriggerInstanceForm$Outbound,
  CreateTriggerInstanceForm$outboundSchema,
} from "../components/createtriggerinstanceform.js";

export type CreateTriggerInstanceSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type CreateTriggerInstanceRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createTriggerInstanceForm: CreateTriggerInstanceForm;
};

/** @internal */
export type CreateTriggerInstanceSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateTriggerInstanceSecurity$outboundSchema: z.ZodMiniType<
  CreateTriggerInstanceSecurity$Outbound,
  CreateTriggerInstanceSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createTriggerInstanceSecurityToJSON(
  createTriggerInstanceSecurity: CreateTriggerInstanceSecurity,
): string {
  return JSON.stringify(
    CreateTriggerInstanceSecurity$outboundSchema.parse(
      createTriggerInstanceSecurity,
    ),
  );
}

/** @internal */
export type CreateTriggerInstanceRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateTriggerInstanceForm: CreateTriggerInstanceForm$Outbound;
};

/** @internal */
export const CreateTriggerInstanceRequest$outboundSchema: z.ZodMiniType<
  CreateTriggerInstanceRequest$Outbound,
  CreateTriggerInstanceRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createTriggerInstanceForm: CreateTriggerInstanceForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      createTriggerInstanceForm: "CreateTriggerInstanceForm",
    });
  }),
);

export function createTriggerInstanceRequestToJSON(
  createTriggerInstanceRequest: CreateTriggerInstanceRequest,
): string {
  return JSON.stringify(
    CreateTriggerInstanceRequest$outboundSchema.parse(
      createTriggerInstanceRequest,
    ),
  );
}
